import { defineStore } from 'pinia';
import {
    oneDay,
    getTodayStartTime,
    calculateDays
} from '../schedule-appointment';

function initState() {
    return {
        listingDetail: null,
        payment: null,
        pricePerMonth: 0,
        agentInfo: null,
        showMakeOffer: false,
        theme: 'standard',
        prevAndNext: {
            prevHref: '',
            canPrev: false,
            nextHref: '',
            canNext: false,
            show: false
        },
        shares: {
            facebookHref: '',
            twitterHref: '',
            linkedinHref: '',
            gmailHref: ''
        },
        showCoAgent: false,
        daysOnSite: 0,
        triggerReadMore: false,
        openReadMore: false,
        hasFavor: false,
        showVirtualTour: true,
        makeOfferButtonText: '',
        makeOfferTitle: '',
        scheduleNameFormat: '',
        schedulePhoneRequired: false,
        soldFormTitle: '',
        soldFormButtonText: '',
        soldFormNameFormat: '',
        soldFormPhoneRequired: false,
        infoFlag: {
            flag: '',
            text: '',
            show: false,
            className: ''
        },
        scheduleTour: {
            appointTime: { date: '', duration: '' },
            selectedDateIndex: 0,
            tourTypeIdx: 0,
            success: false,
            appointmentStartTime: '',
            appointmentEndTime: '',
            offer: { price: '', message: '' }
        },
        company: {
            name: ''
        },
        restrictTimeList: [],
        dayList: [],
        showingConfig: {
            durationType: 30
        }
    };
}

export default storeName =>
    defineStore(storeName, {
        state: initState,
        getters: {},
        actions: {
            updateScheduleTour(params) {
                Object.assign(this.scheduleTour, params);
            },
            updateListingDetail(detail) {
                this.listingDetail = detail;
            },
            updatePayment(payment) {
                this.payment = payment;
            },
            updatePerMonth(pricePerMonth) {
                this.pricePerMonth = pricePerMonth;
            },
            updateAgentInfo(agentInfo) {
                this.agentInfo = agentInfo;
            },
            updateShowCoAgent(showCoAgent) {
                this.showCoAgent = showCoAgent;
            },
            updateShowMakeOffer(showMakeOffer) {
                this.showMakeOffer = showMakeOffer;
            },
            updatePrevAndNext(prevAndNext) {
                this.prevAndNext = prevAndNext;
            },
            updateShare(shares) {
                this.shares = shares;
            },
            updateDaysOnSite(daysOnSite) {
                this.daysOnSite = daysOnSite;
            },
            upTriggerReadMore(triggerReadMore) {
                this.triggerReadMore = triggerReadMore;
            },
            updateOpenReadMore(openReadMore) {
                this.openReadMore = openReadMore;
            },
            toggleOpenReadMore(state) {
                this.openReadMore = !this.openReadMore;
            },
            updateHasFavor(hasFavor) {
                this.hasFavor = hasFavor;
            },
            toggleHasFavor(state) {
                this.hasFavor = !this.hasFavor;
            },
            updateShowVirtualTour(newVal) {
                this.showVirtualTour = newVal;
            },
            updateMakeOfferButtonText(makeOfferButtonText) {
                this.makeOfferButtonText = makeOfferButtonText;
            },
            updateMakeOfferTitle(makeOfferTitle) {
                this.makeOfferTitle = makeOfferTitle;
            },
            updateScheduleNameFormat(scheduleNameFormat) {
                this.scheduleNameFormat = scheduleNameFormat;
            },
            updateSchedulePhoneRequired(schedulePhoneRequired) {
                this.schedulePhoneRequired = schedulePhoneRequired;
            },
            updateSoldFormTitle(soldFormTitle) {
                this.soldFormTitle = soldFormTitle;
            },
            updateSoldFormButtonText(soldFormButtonText) {
                this.soldFormButtonText = soldFormButtonText;
            },
            updateSoldFormNameFormat(soldFormNameFormat) {
                this.soldFormNameFormat = soldFormNameFormat;
            },
            updateSoldFormPhoneRequired(soldFormPhoneRequired) {
                this.soldFormPhoneRequired = soldFormPhoneRequired;
            },
            updateInfoFlag(infoFlag) {
                this.infoFlag = infoFlag;
            },
            updateTheme(theme) {
                this.theme = theme;
            },
            async queryRestrictTimeList() {
                let startTime = getTodayStartTime();
                let endTime = startTime + 30 * oneDay;
                let res = await this.axiosIns.get(
                    '/api-site/record/queryRestrictTime',
                    {
                        params: {
                            listingId: this.listingDetail?.info?.id,
                            startTime,
                            endTime
                        }
                    }
                );
                this.restrictTimeList = res.data || [];
            },
            updateDayList() {
                this.dayList = calculateDays({
                    $t: this.$t,
                    bookedTimeList: this.restrictTimeList,
                    beforeShowingType: 0
                });
            },
            async queryShowingConfig() {
                const DEFAULT_DURATION_TYPE = 30;
                try {
                    let res = await this.axiosIns.get(
                        '/api-site/record/showing-config',
                        {
                            params: {
                                listingId: this.listingDetail?.info?.id
                            }
                        }
                    );
                    let { durationType = DEFAULT_DURATION_TYPE } =
                        res.data || {};
                    this.showingConfig.durationType = durationType;
                } catch (e) {
                    this.showingConfig.durationType = DEFAULT_DURATION_TYPE;
                }
            }
        }
    });
